import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { typography } from '../styles';

const styles = css`

  .CommunityCard_wrapper {
    display: block;
    width: 100%;
    min-height: 450px;
    margin-bottom: 15px;
    position: relative;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 1;
    @media (min-width: 768px) {
      width: 100%;
      min-height: 400px;
    }
    @media (min-width: 992px) {
      width: 100%;
      min-height: 500px;
      margin-bottom: 30px;
      margin-bottom: 30px;
    }
    @media (min-width: 1400px) {
      width: 100%;
      height: 550px;
    }
  }
  .CommunityCard_wrapperAlt{
    @media (min-width: 768px) {
      min-height: 200px;
    }
    @media (min-width: 992px) {
      min-height: 300px;
    }
    @media (min-width: 1400px) {
      height: 350px;
    }
  }
  .CommunityCard_inner {
    display: flex;
    background-image: linear-gradient(180deg, rgba(0,0,0,0.33) 0%, rgba(0,0,0,0.35) 100%);
    width: 100%;
    height: 100%;
    padding: 30px;
    position: absolute;
    top: 0;
    bottom: 0;
    @media (min-width: 768px) {
    }
    @media (min-width: 992px) {
      padding: 30px 15%;
    }
  }
  .CommunityCard_content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
  }

    .Title {
      display: block;
      width: 100%;
      font-family: ${typography.Serif};
      font-weight: 700;
      font-style: italic;
      font-size: 30px;
      color: #FFFFFF;
      letter-spacing: 0.98px;
      text-align: center;
      @media (min-width: 768px) {
        font-size: 35px;
      }
      @media (min-width: 992px) {
        font-size: 47px;
      }

    }
  }

  .Dog {
    display: block;
    width: 130px;
    height: 2px;
    margin: 15px auto;
    background-color: #ffffff;
  }

  .Headline {
    display: block;
    margin: 10px 0 30px 0;
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    line-height: 28px;
    @media (min-width: 992px) {
      line-height: 24px;
    }
    @media (min-width: 1200px) {
      line-height: 28px;
    }
  }

  .VideoLink {
    z-index: 30;
    display: block;
    margin: 30px auto;
    color: #FFFFFF;
    font-weight: 700;
    position: absolute;
    bottom: 20px;
    left: calc(50% - 70px);
    cursor: pointer;
    transition: all .3s ease-out;
    &:hover{
      opacity: .5;
      transition: all .3s ease-out;
    }
    img {
      margin-right: 7px;
    }
  }
.MockBtn{
  transition: all .3s ease-in;
  font-family: ${typography.SansSerif};
  display:block;
  background-color: transparent;
  transition: all .3s ease;
  color: #FFFFFF;
  border-radius: 0;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 3px;
  padding: 15px 20px;
  line-height: normal;
  text-align: center;
  @media (min-width: 768px) {
    padding: 20px 25px;
    font-size: 14px;
  }
}
.Btn{
  margin: 0 auto !important;
}
`;

function CommunityCard({ community, small }) {
  return (
    <div className={styles}>
      <div className={`CommunityCard_wrapper ${small && 'CommunityCard_wrapperAlt'}`} style={{ backgroundImage: `url(${buildThumbnailUrl(get(community, 'photos[0].contentUrl'), { width: 1200, height: 800, preserve: true })})` }}>
        {
          get(community, 'status') !== 'Coming Soon' &&
          <Link
            name="community-detail"
            community={community}
            className="CommunityCard_inner"
          >
            <div className="CommunityCard_content">
              <h4 className="Title">{get(community, 'name')}</h4>
              <div className="Dog" />
              <p className="Headline">{get(community, 'headline')}</p>
              <div className="Btn Hollow">View Neighborhood Detail</div>
            </div>
          </Link>
        }
        {
          get(community, 'status') === 'Coming Soon' &&
          <div className="CommunityCard_inner">
            <div className="CommunityCard_content">
              <h4 className="Title">{get(community, 'name')}</h4>
              <div className="Dog" />
              <p className="Headline">{get(community, 'headline')}</p>
              <div className="MockBtn Hollow">Coming Soon</div>
            </div>
          </div>
        }
      </div>
    </div>
  );
}

CommunityCard.propTypes = {
  community: PropTypes.object.isRequired,
  small: PropTypes.bool,
};

CommunityCard.defaultProps = {
  small: false,
};

export default CommunityCard;



// WEBPACK FOOTER //
// ./src/components/CommunityCard.js